import {
  Title as DefaultTitle,
  Small as DefaultSmall,
  Modal as DefaultModal,
} from '@getinapp/appetizer';
import styled, { css } from 'styled-components';

export const Title = styled(DefaultTitle)`
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.large} !important;
  `}
`;

export const Paragraph = styled.p`
  ${({ theme }) => css`
    color: ${theme.colors.highContrast};
    font-size: 1.5rem;
  `}
`;

export const Small = styled(DefaultSmall)`
  ${({ theme }) => css`
    small {
      font-size: ${theme.font.sizes.xsmall};
    }
  `}
`;

export const Modal = styled(DefaultModal)`
  background: white;

  button > span {
    display: flex;
    align-items: center;
    gap: 0.8rem;
  }
`;

export const OrText = styled.p`
  display: flex;
  text-align: center;
  line-height: 0.1em;
  margin: 1.5rem 0;

  ${({ theme }) => css`
    span {
      border-bottom: 1px solid ${theme.colors.lightContrast};
      width: 100%;
      background: ${theme.colors.white};
      margin: 0 1rem;
    }
  `}
`;
